import React from "react";
import numeral from "numeral";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

class RatesDashboardRateCell extends React.Component {
  constructor(props) {
    super(props);

    this.getTotalRooms = this.getTotalRooms.bind(this);
    this.getHeatMapColor = this.getHeatMapColor.bind(this);
  }

  render() {
    return (
      <div className="RatesDashboardRateCell" style={this.generateStyle()}>
        {this.renderBody()}
      </div>
    );
  }

  renderBody() {
    if (this.props.date_data) {
      var date_data = this.getDateData();
      
      if (!date_data) {
        return <LoadingSpinner show={true} size="small" type="shimmer" />;
      }

      var total_rooms = this.getTotalRooms();
      var rooms_booked = this.getRoomsBooked();
      var heat_map_color = this.getHeatMapColor(
        date_data.rooms_available,
        date_data.rooms_available_last_year,
        total_rooms
      );
      var overrideClassName = "";
      var overridden = this.isOverridden(date_data);
      var overridden_by_season = this.isOverriddenBySeason(date_data);
      var overridden_by_automatic_price_rule =
        this.isOverriddenByAutomaticPriceRule(date_data);

      if (overridden) {
        overrideClassName = "overridden";
      } else if (overridden_by_automatic_price_rule) {
        overrideClassName = "overridden";
      } else if (overridden_by_season) {
        overrideClassName = "overridden-by-season";
      }

      if (
        (date_data.daily_rate && JSON.parse(date_data.daily_rate).blackout) ||
        date_data.is_rate_disabled_by_season ||
        date_data.is_rate_disabled_by_automatic_price_rule ||
        date_data.rate_status === "disabled"
      ) {
        heat_map_color = "#000";
      }

      return (
        <a
          href={this.props.room_type_rate_date_analytics_path}
          className={"modal-iframe " + overrideClassName}
          data-fullscreen="true"
          data-nested="true"
          style={{ background: heat_map_color }}
        >
          <div className="tiny-indicators">
            {overridden_by_automatic_price_rule ? (
              <span
                className="tiny-indicator"
                title={I18n.t("overridden_by_dynamic_rate")}
              >
                {I18n.t("dynamic_rate_icon")}
              </span>
            ) : null}
            {overridden_by_season ? (
              <span
                className="tiny-indicator"
                title={I18n.t("overridden_by_season")}
              >
                {I18n.t("season_icon")}
              </span>
            ) : null}
            {overridden ? (
              <span
                className="tiny-indicator"
                title={I18n.t("overridden_by_daily_rate")}
              >
                {I18n.t("daily_rate_icon")}
              </span>
            ) : null}
          </div>
          {this.renderAmountOrMinimumStay(heat_map_color)}
          {rooms_booked === total_rooms ? (
            <span
              className="ss-ban"
              style={{
                fontSize: "12px",
                color: "#AFAFAF",
                marginTop: "-1px",
              }}
            />
          ) : (
            <span className="badge" title={I18n.t("rooms_booked")}>
              {rooms_booked}/{total_rooms}
            </span>
          )}
        </a>
      );
    } else {
      return (
        <div className="code">
          {this.props.rate.rate_type == "special" ? (
            <span style={{ display: "inline" }}>
              <a
                className="modal-iframe"
                style={{ display: "inline" }}
                data-fullscreen="true"
                data-nested="true"
                href={this.props.rate.edit_admin_rate_path}
              >
                {this.props.rate.code}
                <span
                  className="ss-star star custom-span"
                  title={I18n.t("special_rate")}
                ></span>
              </a>
            </span>
  
          ) : (
            <span style={{ display: "inline" }}>
              <a
                className="modal-iframe"
                style={{ display: "inline" }}
                data-fullscreen="true"
                data-nested="true"
                href={this.props.rate.edit_admin_rate_path}
              >
                {this.props.rate.code}
              </a>
            </span>
          )}
        </div>
      );
    }
  }

  isOverridden(date_data) {
    var has_daily_rate = false;
    for (var i = 0, ilen = this.props.date_data.length; i < ilen; i++) {
      if (
        this.props.date_data[i].room_type_id == this.props.room_type.id &&
        this.props.date_data[i].rate_id == this.props.rate.id
      ) {
        if (this.props.date_data[i].daily_rate) {
          has_daily_rate = true;
          break;
        }
      }
    }
    return has_daily_rate;
  }

  isOverriddenBySeason(date_data) {
    if (date_data.seasonal_rate || date_data.is_rate_disabled_by_season) {
      return true;
    }
  }

  isOverriddenByAutomaticPriceRule(date_data) {
    if (
      date_data.is_rate_disabled_by_automatic_price_rule ||
      date_data.automatic_price_rules_rate
    ) {
      return true;
    }
  }

  renderAmountOrMinimumStay(heat_map_color) {
    if (this.props.toggleSetting == "prices" || this.props.toggleSetting == "daily_rentals") {
      const amount = this.getAmount();
      return (
        <span
          className="amount"
          style={{
            color:
              this.lightOrDark(heat_map_color) == "dark" ? "#DFDFDF" : "#222",
          }}
        >
          {amount > 0 ? (
            <span>
              <sup>{I18n.t("number.currency.format.unit")}</sup>
              {numeral(amount / 100).format("0,000")}
            </span>
          ) : null}
        </span>
      );
    } else {
      // minimum stay
      return (
        <span
          className="amount minimum_stay"
          style={{
            color:
              this.lightOrDark(heat_map_color) == "dark" ? "#DFDFDF" : "#222",
          }}
        >
          {this.getMinimumStay()}
        </span>
      );
    }
  }

  /**
   * Helper functions
   */

  getAmount() {
    for (var i = 0, ilen = this.props.date_data.length; i < ilen; i++) {
      if (
        this.props.date_data[i].room_type_id == this.props.room_type.id &&
        this.props.date_data[i].rate_id == this.props.rate.id
      ) {
        if (
          this.props.date_data[i].daily_rate &&
          this.props.date_data[i].daily_rate.amount
        ) {
          return this.props.date_data[i].daily_rate.amount;
        } else {
          return this.props.date_data[i].rate_amount;
        }
      }
    }
  }

  getMinimumStay() {
    for (var i = 0, ilen = this.props.date_data.length; i < ilen; i++) {
      if (
        this.props.date_data[i].room_type_id == this.props.room_type.id &&
        this.props.date_data[i].rate_id == this.props.rate.id
      ) {
        if (
          this.props.date_data[i].daily_rate &&
          this.props.date_data[i].daily_rate.minimum_stay
        ) {
          return this.props.date_data[i].daily_rate.minimum_stay;
        } else {
          return this.props.date_data[i].minimum_stay;
        }
      }
    }
  }

  getRoomsBooked() {
    var booked = 0;
    for (var i = 0, ilen = this.props.date_data.length; i < ilen; i++) {
      if (
        this.props.date_data[i].room_type_id == this.props.room_type.id &&
        this.props.date_data[i].rate_id == this.props.rate.id
      ) {
        return this.props.date_data[i].rooms_booked_with_rate;
      }
    }
    return booked;
  }

  getTotalRooms() {
    for (var i = 0, ilen = this.props.date_data.length; i < ilen; i++) {
      if (
        this.props.date_data[i].room_type_id == this.props.room_type.id &&
        this.props.date_data[i].rate_id == this.props.rate.id
      ) {
        return this.props.date_data[i].total_rooms;
      }
    }
  }

  generateStyle() {
    if (
      typeof this.props.top != "undefined" &&
      typeof this.props.left != "undefined"
    ) {
      return { top: this.props.top + "px", left: this.props.left + "px" };
    } else {
      return { top: this.props.top + "px" };
    }
  }

  getDateData() {
    var redAlert = null;
    for (var i = 0, ilen = this.props.date_data.length; i < ilen; i++) {
      if (
        this.props.date_data[i].room_type_id == this.props.room_type.id &&
        this.props.rate.id == this.props.date_data[i].rate_id
      ) {
        redAlert = this.props.date_data[i];
      }
    }
    if (redAlert == null) {
      // no date data
    }
    return redAlert;
  }

  getHeatMapColor(
    rooms_available_this_year,
    rooms_available_last_year,
    total_rooms
  ) {
    if (!this.props.heatMapColors) {
      return;
    }

    var diff = rooms_available_last_year - rooms_available_this_year;
    if (diff < 0) {
      // we're behind - use last 3 colors
      var percent = Math.round(Math.abs(diff / total_rooms) * 100);
      if (percent <= 33) {
        return this.props.heatMapColors[4]; //#FF6600 slightly_behind_pace;
      } else if (percent > 33 && percent <= 67) {
        return this.props.heatMapColors[5]; //#FF3300 behind_pace;
      } else {
        return this.props.heatMapColors[6]; //#CC0000 very_behind_pace;
      }
    } else if (diff > 0) {
      // we're ahead - use first 3 colors
      var percent = Math.round(Math.abs(diff / total_rooms) * 100);
      if (percent <= 33) {
        return this.props.heatMapColors[2]; //#33CC33 slightly_ahead_of_pace;
      } else if (percent > 33 && percent <= 67) {
        return this.props.heatMapColors[1]; // #339933 ahead_of_pace;
      } else {
        return this.props.heatMapColors[0]; // #336633 very_ahead_of_pace;
      }
    } else {
      // we're the same - use middle color
      return this.props.heatMapColors[3]; // #FFCC00 on_pace;
    }
  }

  lightOrDark(color) {
    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {
      // If HEX --> store the red, green, blue values in separate variables
      color = color.match(
        /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
      );

      var r = color[1];
      var g = color[2];
      var b = color[3];
    } else {
      // If RGB --> Convert it to HEX: http://gist.github.com/983661
      color = +(
        "0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&")
      );

      var r = color >> 16;
      var g = (color >> 8) & 255;
      var b = color & 255;
    }

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    var hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 127.5) {
      return "light";
    } else {
      return "dark";
    }
  }
}

export default RatesDashboardRateCell;
